module.exports = __webpack_public_path__ + "static/trello-c3af5aa34b63decc52904c853ca1002c.svg";